import {
  AfterViewInit,
  Component,
  Directive,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';

import {environment} from '../../../../environments/environment';
import {language} from '../../../language/vn';
import {CommandUtil} from '../../../global/commandutil';
import {DatePipe} from '@angular/common';
import {Sessioncommand} from '../../../global/sessioncommand';
import {BsModalService} from 'ngx-bootstrap/modal';
import {ToastrService} from 'ngx-toastr';
import { YKienThongBaoComponent} from './ykien.component';
import {NavItemService} from '../../../service/staff/service-navitem';
import {ThongBao} from '../../../models/info/thongbao';
import {ThongBaoFile} from '../../../models/info/thongbaofile';
import {ThongBaoService} from '../../../service/info/service-thongbao';
import {ThongBaoFileService} from '../../../service/info/service-thongbaofile';
import {ThongBaoComment} from '../../../models/info/thongbaocomment';
import {ThongBaoCommentService} from '../../../service/info/service-thongbaocomment';
import {YKTongHopThongBaoComponent} from './tonghop.component';
import {FileThongBaoComponent} from './file.component';
import {FormatService} from '../../../service/format/service-format';
import {ThemNNThongBaoComponent} from './share.component';
import {ThongBaoStaff} from '../../../models/info/thongbaostaff';
import {ThongBaoStaffService} from '../../../service/info/service-thongbaostaff';
import {DomSanitizer} from '@angular/platform-browser';
@Component({
  selector: 'xulythongbao-detail',
  templateUrl: './xulydetail.component.html',

})
export class XuLyDetailThongBaoComponent implements OnInit, AfterViewInit {
  @Input() thongBaoId: number = 0;
  @Output() backMethod: EventEmitter<string> = new EventEmitter();
  @Output() nextPage: EventEmitter<string> = new EventEmitter();
  @Output() backPage: EventEmitter<string> = new EventEmitter();
  @Output() currentId: EventEmitter<any> = new EventEmitter();
  public totalItems: number = 0;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public numTBPages: number = environment.numberPages;
  public totalTBItems: number = 0;
  public currentTBPage: number   = environment.currentPage;
  public language = language;
  public showAction = true;
  public dataList: ThongBao [] = [];
  public thongBaoItem: ThongBao = new ThongBao();
  public thongBaoFiles: ThongBaoFile[] = [];
  public thongBaoCommentList: ThongBaoComment[]=[];
  public fileLists: Object[]=[];
  public maNguoiXuLy: number = Sessioncommand.staffId;
  public permissionAdmin: boolean = false;
  public dateCurrent: Date = new Date();
  public urlExportThongBao: string = environment.exportThongBao;
  public urlPrintThongBao: string= environment.printThongBao;
  public thongBaoStaffList: ThongBaoStaff[] = [];
  constructor(
    public thongBaoService: ThongBaoService,
    public datepipe: DatePipe,
    public toastr: ToastrService,
    public commandUtil: CommandUtil,
    public thongBaoFileService: ThongBaoFileService,
    public bsModalService: BsModalService,
    public thongBaoCommentService: ThongBaoCommentService,
    public navItemService: NavItemService,
    public formatService: FormatService,
    public thongBaoStaffService: ThongBaoStaffService,
    public sanitizer: DomSanitizer
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number)
  {
    this.thongBaoId = id;
    this.thongBaoService.getByStaffReadId(id, Sessioncommand.staffId).subscribe(x => this.thongBaoItem = x);
    this.thongBaoFileService.findAllByThongBaoId(id).subscribe( x => this.thongBaoFiles = x);
    this.loadComment(this.thongBaoId);
    this.currentId.emit(id);
    this.loadReadThongBao(this.dataList);

  }
  ngOnInit(): void {
    this.formatService.getCurrentDateVN().subscribe( x => this.dateCurrent = this.commandUtil.getDate(x));
    this.edit(this.thongBaoId);
    this.navItemService.checkPermissionByCode(Sessioncommand.staffId,"0001", true).subscribe(
      x => { this.permissionAdmin = x> 0? true: false;
        this.searchOther();
      }
    );
  }
  searchOther()
  {
    this.thongBaoService.findAllByPaging('', this.permissionAdmin === true?-1: Sessioncommand.staffId, -1, this.currentTBPage, this.maxSize)
      .subscribe(dataList => {
        this.dataList = dataList;
        this.loadReadThongBao(this.dataList);
      });
    this.thongBaoService.getCountByKeyword('', this.permissionAdmin === true?-1: Sessioncommand.staffId,  -1).subscribe(recordCount => this.totalTBItems = recordCount);
  }

  loadReadThongBao(dataThongBao: ThongBao[])
  {
    if(dataThongBao !== null && dataThongBao.length > 0) {
      const arrIds = dataThongBao.map(x => x.id).join(',');
      this.thongBaoStaffService.findAllByThongBaoIdArray(arrIds, Sessioncommand.staffId)
        .subscribe(dataList => {
          this.thongBaoStaffList = dataList;
        });
    }
  }
  checkRead(id: number): boolean
  {
    if (this.thongBaoStaffList === null || this.thongBaoStaffList.length === 0)
      return false;
    return this.thongBaoStaffList.findIndex(x => x.thongBaoID === id) !== -1 ? true: false;
  }

  public loadComment(id: number)
  {
    this.thongBaoCommentService.getCountByKeyword(id, Sessioncommand.staffId).subscribe( data => this.totalItems = data);
    this.thongBaoCommentService.findAllByPaging(id, Sessioncommand.staffId, this.currentPage, this.maxSize).subscribe( data => this.thongBaoCommentList = data);
  }
  public yKienTongHop() {
    const modalEdit = this.bsModalService.show(YKTongHopThongBaoComponent, {class: 'modal-lg'});
    (<YKTongHopThongBaoComponent>modalEdit.content).edit(
      this.thongBaoId
    );
    (<YKTongHopThongBaoComponent>modalEdit.content).onClose.subscribe(result => {
    });

  }
  public yKienXuLy() {
    const modalEdit = this.bsModalService.show(YKienThongBaoComponent, {class: 'modal-lg'});
    (<YKienThongBaoComponent>modalEdit.content).edit(
      this.thongBaoId
    );
    (<YKienThongBaoComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.thongBaoId);
    });

  }
  public themNguoiNhan() {
    const modalEdit = this.bsModalService.show(ThemNNThongBaoComponent, {class: 'modal-lg'});
    (<ThemNNThongBaoComponent>modalEdit.content).edit(
      this.thongBaoId
    );
    (<ThemNNThongBaoComponent>modalEdit.content).onClose.subscribe(result => {
      this.edit(this.thongBaoId);
    });

  }

  public thayFile(id: number) {
    const modalEdit = this.bsModalService.show(FileThongBaoComponent, {class: 'modal-lg'});
    (<FileThongBaoComponent>modalEdit.content).edit(
      id
    );
    (<FileThongBaoComponent>modalEdit.content).onClose.subscribe(result => {
      this.loadComment(this.thongBaoId);
    });

  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.loadComment(this.thongBaoId);
  }
  pageTBChanged(event: any): void {
    this.currentTBPage = event.page;
    this.searchOther();
  }
}

